import Content from 'layouts/Content';


export default function NotFound() {
  return (
    <Content className="text-center">
      404 bud
    </Content>
  );
}
